export default __webpack_public_path__ + "images/1bd3137902b61f9a80f74da8ff4524d9-state_small.webp";